import {
  ExperiencePageTargetingDto,
  PageTargetingExpressionPayload,
} from "@intelligems/ig-types";
import { expressionListToPostFix } from "@intelligems/ig-utils";
import * as rtk from "@reduxjs/toolkit";
import { type PayloadAction } from "@reduxjs/toolkit";
import { initialPageTargetingState } from "@src/api/initials";

import { initialIPageTargetingState } from "../types/pageTargeting";

const pageTargetingSlice = rtk.createSlice({
  name: "pageTargeting",
  initialState: initialIPageTargetingState,
  reducers: {
    resetPageTargeting: (draft) => {
      draft = initialIPageTargetingState;
      return draft;
    },
    resetPageTargetingToStored: (draft) => {
      draft.pageTargeting = draft.storedPageTargeting;
    },
    initPageTargeting: (
      draft,
      action: PayloadAction<{ pageTargeting: ExperiencePageTargetingDto[] }>
    ) => {
      draft.isSuccess = true;
      draft.pageTargeting = action.payload.pageTargeting;
      draft.storedPageTargeting = action.payload.pageTargeting;
    },
    updatePageTargeting: (
      draft,
      action: PayloadAction<{
        experienceId?: string;
        expressionsList: PageTargetingExpressionPayload[];
      }>
    ) => {
      const postFix = expressionListToPostFix(
        action.payload.expressionsList,
        "pageTargeting"
      );
      if (!postFix.length) {
        draft.pageTargeting = [];
        return;
      }

      if (draft.pageTargeting.length) {
        draft.pageTargeting = [
          {
            ...draft.pageTargeting[0],
            experienceId: action.payload.experienceId,
            expression: postFix,
          },
        ];
      } else {
        draft.pageTargeting = [
          {
            ...initialPageTargetingState(action.payload.experienceId),
            expression: postFix,
          },
        ];
      }
      return draft;
    },
  },
  selectors: {
    selectedPageTargetingState: (state) => state,
    selectedPageTargeting: (state) => state.pageTargeting,
    selectedStoredPageTargeting: (state) => state.storedPageTargeting,
  },
});

export const {
  resetPageTargeting,
  initPageTargeting,
  updatePageTargeting,
  resetPageTargetingToStored,
} = pageTargetingSlice.actions;

export const pageTargetingReducer = pageTargetingSlice.reducer;
export const {
  selectedPageTargetingState,
  selectedStoredPageTargeting,
  selectedPageTargeting,
} = pageTargetingSlice.selectors;
